import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import { useTranslations } from '../../hooks/use-translations';

import styles from './list.module.scss';

export const List = ({ items, linkGenerator, messageEmpty }) => {
	const defaultLabelNoItems = useTranslations('NO_ITEMS');

	if (items.length === 0) {
		return <em className={styles.message}>{messageEmpty || defaultLabelNoItems}</em>;
	}

	return (
		<div className={styles.wrapper}>
			{items.map((item) => {
				const path = linkGenerator(item);
				return <Item key={path} path={path} {...item} />;
			})}
		</div>
	);
};

List.defaultProps = {
	items: [],
	messageEmpty: '',
	linkGenerator: () => '',
};

List.propTypes = {
	items: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
	messageEmpty: PropTypes.string,
	linkGenerator: PropTypes.func.isRequired,
};

export default List;

const Item = ({ name, path, image }) => (
	<Link to={path} className={styles.item}>
		{image.file && (
			<div className={styles.image}>
				<GatsbyImage
					alt={image.alt}
					title={image.title}
					image={image.file.childImageSharp.gatsbyImageDataFixed}
				/>
			</div>
		)}

		<div className={styles.caption}>
			<strong>{name}</strong>
		</div>
	</Link>
);

Item.propTypes = {
	name: PropTypes.string.isRequired,
	path: PropTypes.string.isRequired,
	image: PropTypes.object.isRequired,
};
